import { FC } from "react";
import { ArrowUpward, TrendingDown, TrendingUp } from "@mui/icons-material";
import { ExplainWithAiAnomaliesTypes } from "@/components/pages/resource-explorer/components/explain-with-ai-panel/components/utils/types";

export const anomaliesIcons: Record<ExplainWithAiAnomaliesTypes, FC<any>> = {
  spikes: ArrowUpward,
  decreaseTrends: TrendingDown,
  increaseTrends: TrendingUp,
};
